import { LivquestCalviNav } from '../components/livquest-calvi/nav';
import { LivquestCalviSidebarBottom } from '../components/livquest-calvi/sidebar';
import HelloView from '../components/livquest-calvi/hello';
import { LivquestCalviLogo } from '../components/livquest-calvi/logo';

export const SIDEBAR_MENU = LivquestCalviNav;
export const SIDEBAR_BOTTOM = LivquestCalviSidebarBottom;

export const HELLO_CONTENT = HelloView;
export const LOGO = LivquestCalviLogo;

export const RADIO_STATION = 'ldrm';
export const HAS_AUTO_PLAY = true;

export const CHATBAR_CLASS = 'mix-blend-overlay opacity-70';
export const USERBALL_CLASS = '';
export const MICROPHONE_CLASS = '';
export const BG_CLASS = 'livquest-calvi-bg';
export const LIV_NAME = '';
export const USE_ELEVENLABS = true;
export const APP_NAME = 'livquest-calvi';
export const API_NAME = 'livquest';

export const ASK_LIV = 'Posez-moi une question…';
